import { createApp } from 'vue'
import App from './App.vue'
import { posthog, posthogEnabled } from './posthog'
import { router } from './router'
import { bootSentry } from './sentry'
import './assets/main.css'
import './lib/catalog' // Import catalog functions for tests

const app = createApp(App)
app.use(router)
void bootSentry(app, router)
const previousErrorHandler = app.config.errorHandler
app.config.errorHandler = (error, instance, info) => {
    if (posthogEnabled) posthog.captureException(error, { vue_info: info })
    if (previousErrorHandler) previousErrorHandler(error, instance, info)
    else console.error(error)
}
app.mount('#app')
